import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";

const sections = [
  {
    title: "1. Éditeur de l'application",
    body: (
      <>
        <p>Lift AI est éditée par Pulsar Plateformes.</p>
        <p>
          Contact :{" "}
          <a
            href="mailto:contact@liftai.fr"
            className="text-violet-600 hover:underline"
          >
            contact@liftai.fr
          </a>
        </p>
        <p>Pays : France</p>
      </>
    ),
  },
  {
    title: "2. Données collectées",
    body: (
      <>
        <p>
          Lift AI peut collecter certaines données afin d'assurer le bon
          fonctionnement de l'application et proposer une expérience
          personnalisée.
        </p>
        <p>
          Ces informations sont explicitement données par l'utilisateur
          lui-même. Les données pouvant être collectées incluent notamment :
        </p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Adresse email</li>
          <li>Pseudo ou nom d'utilisateur</li>
          <li>Photos envoyées par l'utilisateur</li>
          <li>Données physiques et mensurations (taille, poids, âge, etc.)</li>
          <li>Informations liées à l'utilisation de l'application</li>
          <li>Notifications et préférences utilisateur</li>
        </ul>
        <p>
          Les photos et données transmises sont utilisées uniquement dans le
          cadre des fonctionnalités proposées par Lift AI et peuvent être
          supprimées à tout moment par l'utilisateur.
        </p>
      </>
    ),
  },
  {
    title: "3. Utilisation des données",
    body: (
      <>
        <p>Les données collectées sont utilisées pour :</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Fournir les fonctionnalités de l'application</li>
          <li>Générer des analyses physiques via l'intelligence artificielle</li>
          <li>Créer des programmes personnalisés</li>
          <li>Améliorer l'expérience utilisateur</li>
          <li>Améliorer les performances et la personnalisation de l'application</li>
          <li>Assurer la sécurité et le bon fonctionnement du service</li>
        </ul>
        <p>
          Les données ne sont ni revendues ni partagées à des fins
          commerciales.
        </p>
      </>
    ),
  },
  {
    title: "4. Intelligence artificielle",
    body: (
      <p>
        Lift AI utilise des services d'intelligence artificielle fournis par{" "}
        <a
          href="https://www.anthropic.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-violet-600 hover:underline"
        >
          Anthropic
        </a>{" "}
        et{" "}
        <a
          href="https://ai.google"
          target="_blank"
          rel="noopener noreferrer"
          className="text-violet-600 hover:underline"
        >
          Google
        </a>{" "}
        afin d'analyser certaines informations envoyées par les utilisateurs
        (telles que la taille, le poids, le matériel à disposition etc.) et de
        générer des recommandations personnalisées.
      </p>
    ),
  },
  {
    title: "5. Services tiers utilisés",
    body: (
      <>
        <p>
          Lift AI peut utiliser des services tiers pour assurer son
          fonctionnement, notamment :
        </p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>
            <a
              href="https://supabase.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-600 hover:underline"
            >
              Supabase
            </a>
          </li>
          <li>
            <a
              href="https://www.anthropic.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-600 hover:underline"
            >
              Anthropic
            </a>
          </li>
          <li>
            <a
              href="https://ai.google"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-600 hover:underline"
            >
              Google
            </a>
          </li>
          <li>
            <a
              href="https://superwall.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-600 hover:underline"
            >
              Superwall
            </a>
          </li>
          <li>
            <a
              href="https://www.apple.com/app-store/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-violet-600 hover:underline"
            >
              Apple App Store
            </a>
          </li>
        </ul>
        <p>
          Ces services peuvent traiter certaines données nécessaires au
          fonctionnement de l'application.
        </p>
      </>
    ),
  },
  {
    title: "6. Stockage et sécurité",
    body: (
      <>
        <p>
          Les données sont stockées de manière sécurisée via des services
          d'hébergement et de base de données utilisés par Lift AI.
        </p>
        <p>
          Lift AI met en œuvre des mesures afin de protéger les données des
          utilisateurs contre les accès non autorisés, pertes ou utilisations
          abusives.
        </p>
      </>
    ),
  },
  {
    title: "7. Comptes utilisateurs",
    body: (
      <>
        <p>Les utilisateurs peuvent :</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>créer un compte via Apple ou Google,</li>
          <li>se déconnecter à tout moment,</li>
          <li>demander la suppression de leur compte et de leurs données personnelles.</li>
        </ul>
      </>
    ),
  },
  {
    title: "8. Abonnements",
    body: (
      <>
        <p>
          L'accès complet à l'application Lift AI nécessite un paiement ou
          abonnement payant.
        </p>
        <p>
          Les paiements et abonnements sont gérés directement par Apple via
          l'App Store.
        </p>
      </>
    ),
  },
  {
    title: "9. Modifications",
    body: (
      <p>
        Cette politique de confidentialité peut être modifiée à tout moment
        afin de refléter les évolutions de l'application ou les obligations
        légales.
      </p>
    ),
  },
  {
    title: "10. Contact",
    body: (
      <p>
        Pour toute question concernant cette politique de confidentialité :{" "}
        <a
          href="mailto:contact@liftai.fr"
          className="text-violet-600 hover:underline"
        >
          contact@liftai.fr
        </a>
      </p>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <main
      data-testid="privacy-policy-page"
      className="bg-white text-neutral-950 font-[Instrument_Sans]"
    >
      <Header />

      <section className="pt-32 pb-16 lg:pt-40 lg:pb-20 px-6 lg:px-10 border-b border-neutral-200">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-violet-600 transition-colors mb-8 group"
          >
            <ArrowLeft
              size={14}
              className="group-hover:-translate-x-0.5 transition-transform"
            />
            Retour à l'accueil
          </Link>

          <p className="text-sm font-medium text-violet-600 mb-4 uppercase tracking-wider">
            Légal
          </p>
          <h1
            data-testid="privacy-page-title"
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-neutral-950 mb-6"
          >
            Politique de confidentialité
          </h1>
          <p className="text-base text-neutral-500">
            Dernière mise à jour : Mai 2026
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4 text-lg text-neutral-700 leading-relaxed mb-16">
            <p>
              Bienvenue sur Lift AI, une application éditée par Pulsar
              Plateformes.
            </p>
            <p>
              La présente politique de confidentialité explique quelles données
              sont collectées lors de l'utilisation de l'application Lift AI et
              comment elles sont utilisées.
            </p>
          </div>

          <div className="space-y-14">
            {sections.map((s, i) => (
              <article
                key={s.title}
                data-testid={`privacy-section-${i}`}
                className="scroll-mt-24"
              >
                <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-neutral-950 mb-5">
                  {s.title}
                </h2>
                <div className="space-y-4 text-base text-neutral-700 leading-relaxed">
                  {s.body}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
